import axios from "axios";
import { CheckLoginServer } from "../Helpers/CheckLogin";
import { BaseUrl } from "./Base";

const axiosInstance = axios.create({
    baseURL: BaseUrl,
    withCredentials: true,
});

export const GetStudentsA = () => async (dispatch) => {
    try {
        dispatch({
            type: "GetStudentsListRequest",
        });

        const { data } = await axiosInstance.get(`/api/Enrolled/students`);

        dispatch({
            type: "GetStudentsListSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetStudentsListError",
            payload: error,
        });
    }
};

//Student list Enrollment Status Inprogress
export const GetStatusInProgressStudentsA = () => async (dispatch) => {
    try {
        dispatch({
            type: "GetStatusInProgressStudentsListRequest",
        });

        const { data } = await axiosInstance.get(
            `/api/Enrolled/StatusInProgress/students`
        );

        dispatch({
            type: "GetStatusInProgressStudentsListSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetStatusInProgressStudentsListError",
            payload: error,
        });
    }
};

//GET Students with Course Enrollment status on Hold
export const GetStatusHoldStudentsA = () => async (dispatch) => {
    try {
        dispatch({
            type: "etStatusHoldStudentsListRequest",
        });

        const { data } = await axiosInstance.get(
            `/api/Enrolled/StatusHold/students`
        );

        dispatch({
            type: "GetStatusHoldStudentsListSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetStatusHoldStudentsListError",
            payload: error,
        });
    }
};

export const GetClassScheduleA = (EnrollmentId) => async (dispatch) => {
    try {
        dispatch({
            type: "GetClassScheduleRequest",
        });

        const { data } = await axiosInstance.get(
            `/api/course/schedule/${EnrollmentId}`
        );
        dispatch({
            type: "GetClassScheduleSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetClassScheduleError",
            payload: error,
        });
    }
};

// export const GetProgressAndCourse = (EnrollmentId) => async (dispatch) => {
//     try {
//         dispatch({
//             type: "GetAboutClientRequest",
//         });

//         const { data } = await axiosInstance.get(
//             `/api/courseprogress/${EnrollmentId}`
//         );
//         dispatch({
//             type: "GetAboutClientSuccess",
//             payload: data,
//         });
//     } catch (error) {
//         CheckLoginServer(error?.response?.data, dispatch);
//         dispatch({
//             type: "GetAboutClientError",
//             payload: error,
//         });
//     }
// };

export const CreateScheduleA = (Events,cb, errorCb) => async (dispatch) => {
    try {
        dispatch({
            type: "CreateStudentClassesScheduleRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/schedule/create`,
            Events
        );
        dispatch({
            type: "CreateStudentClassesScheduleSuccess",
            payload: data,
        });
        cb();

    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "CreateStudentClassesScheduleFailure",
            payload: error,
        });
        if (errorCb) errorCb(error?.response?.data?.message || "Something went wrong"); // ✅ error callback
    }
};

export const UpdateScheduleA = (Events) => async (dispatch) => {
    try {
        dispatch({
            type: "UpdateScheduleRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/schedule/update`,
            Events
        );
        dispatch({
            type: "UpdateScheduleSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "UpdateScheduleFailure",
            payload: error,
        });
    }
};

export const ChangeScheduleStatus = (EventId, status, ClassFeedback) => async (dispatch) => {
    try {
        dispatch({
            type: "ChangeScheduleStatusRequest",
        });

        // Send EventId and status in the request body
        const { data } = await axiosInstance.put(
            `/api/schedule/changestatus`,
            { EventId, status, ClassFeedback }  // Send as an object
        );

         // Log the response data to ensure it's structured correctly
         console.log("Response data:", data);


        dispatch({
            type: "ChangeScheduleStatusSuccess",
            payload: data,  // Assuming data contains the updated schedule
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        
        dispatch({
            type: "ChangeScheduleStatusFailure",
            payload: error?.response?.data?.message || error.message, // Provide a specific error message
        });
    }
};

export const GetScheduleA = (EnrollmentId) => async (dispatch) => {
    try {
        dispatch({
            type: "GetTimeTableRequest",
        });

        const { data } = await axiosInstance.get(
            `/api/timetable/${EnrollmentId}`
        );
        dispatch({
            type: "GetTimeTableSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetTimeTableError",
            payload: error,
        });
    }
};

export const GetCourseNameA = (EnrollmentId) => async (dispatch) => {
    try {
        dispatch({
            type: "GetCourseNameRequest",
        });

        const { data } = await axiosInstance.get(
            `/api/GetCourseName/${EnrollmentId}`
        );
        dispatch({
            type: "GetCourseNameSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetCourseNameFailure",
            payload: error,
        });
    }
};

export const GetSubscriptionStatus = (EnrollmentId) => async (dispatch) => {
    try {
        dispatch({
            type: "SubscriptionRequest",
        });
        const { data } = await axiosInstance.get(
            `/api/Status/payment/${EnrollmentId}`
        );

        dispatch({
            type: "SubscriptionSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "SubscriptionFailure",
            payload: error,
        });
    }
};

// Action to get user by ID
export const GetUserByIdA = (userId) => async (dispatch) => {
    try {
        dispatch({
            type: "GetUserByIdRequest",
        });

        console.log("user id in action is:", userId)

        const { data } = await axiosInstance.get(`/api/getuserbyid/${userId}`);

        dispatch({
            type: "GetUserByIdSuccess",
            payload: data,
        });
    } catch (error) {
       // Serialize the error
       const serializedError = {
        message: error.message,
        code: error.code,
        response: error.response ? {
            status: error.response.status,
            data: error.response.data,
        } : null,
    };
        dispatch({
            type: "GetUserByIdFailure",
            payload: serializedError,

        });
    }
};

//update student settings field at the backend
export const UpdateSettingsField = (UserId,formData) => async (dispatch) => {
    try {
        console.log("UserId in UpdateSettingsField action is:", UserId)
        console.log("formData in UpdateSettingsField action is:", formData)

        dispatch({
            type: "UpdateSettingsFieldsRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/student/settings/${UserId}`,
            formData
        );

        dispatch({
            type: "UpdateSettingsFieldsSuccess",
            payload: data,
        });
        return Promise.resolve(); // Indicate success
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "UpdateSettingsFieldsFailure",
            payload: error,
        });
        return Promise.reject(); // Indicate failure
    }
};

//Get student Notification data
export const GetStudentNotificationData = (UserId) => async (dispatch) => {
    try {
        console.log("UserId in GetStudentNotificationData action is:", UserId)

        dispatch({
            type: "GetStudentNotificationDataRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/student/settings/NotificationsData/${UserId}`
        );

        dispatch({
            type: "GetStudentNotificationDataSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetStudentNotificationDataFailure",
            payload: error,
        });
    }
};

//Update student Notification Personal data
export const UpdateStudentPersonalNotificationData = (UserId, notifications, cb) => async (dispatch) => {
    try {
        console.log("UserId in UpdateStudentPersonalNotificationData action is:", UserId)
        console.log("notifications in UpdateStudentPersonalNotificationData action is:", notifications)

        dispatch({
            type: "UpdateStudentNotificationDataRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/student/settings/UpdateNotificationsData/${UserId}`,
            { notifications }
        );

        dispatch({
            type: "UpdateStudentNotificationDataSuccess",
            payload: data,
        });

        cb();
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "UpdateStudentNotificationDataFailure",
            payload: error,
        });
    }
};

//UpdateUserPaymentMethod data
// export const UpdateUserPaymentMethod = (dataToSend, UserId, cb) => async (dispatch) => {
//     try {
//         console.log("UserId in UpdateUserPaymentMethod action is:", UserId)
//         console.log("dataToSend in UpdateUserPaymentMethod action is:", dataToSend)

//         dispatch({
//             type: "UpdateStudentNotificationDataRequest",
//         });
//         const { data } = await axiosInstance.post(
//             `/api/student/settings/UpdateUserPaymentMethod/${UserId}`,
//             { dataToSend }
//         );

//         dispatch({
//             type: "UpdateStudentNotificationDataSuccess",
//             payload: data,
//         });
//         cb();
//         // return Promise.resolve(); // Indicate success
//     } catch (error) {
//         CheckLoginServer(error?.response?.data, dispatch);
//         dispatch({
//             type: "UpdateStudentNotificationDataFailure",
//             payload: error,
//         });
//         // return Promise.reject(); // Indicate failure
        
//     }
// };

export const UpdateUserPaymentMethod = (dataToSend, UserId, onSuccess, onError) => async (dispatch) => {
    try {
        dispatch({ type: "UpdateStudentNotificationDataRequest" });

        const { data } = await axiosInstance.post(
            `/api/student/settings/UpdateUserPaymentMethod/${UserId}`,
            { dataToSend }
        );

        dispatch({
            type: "UpdateStudentNotificationDataSuccess",
            payload: data,
        });

        onSuccess(); // success callback
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "UpdateStudentNotificationDataFailure",
            payload: error,
        });

        const errorMsg = error?.response?.data?.message || "An error occurred while updating the payment method.";
        onError(errorMsg); // failure callback
    }
};


//GetUserPaymentMethod data
export const GetUserPaymentMethod = (UserId) => async (dispatch) => {
    try {
        console.log("UserId in GetUserPaymentMethod action is:", UserId)

        dispatch({
            type: "GetUserPaymentMethodDataRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/student/settings/GetUserPaymentMethod/${UserId}`
        );

        dispatch({
            type: "GetUserPaymentMethodDataSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetUserPaymentMethodDataFailure",
            payload: error,
        });
    }
};

//GetUserPaymentMethod data
export const UpdateUserPaymentDefaultField = (UserId, paymentMethodId) => async (dispatch) => {
    try {
        console.log("UserId in UpdateUserPaymentDefaultField action is:", UserId)
        console.log("paymentMethodId in UpdateUserPaymentDefaultField action is:", paymentMethodId)

        dispatch({
            type: "UpdateStudentNotificationDataRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/student/settings/UpdateUserPaymentDefaultField/${UserId}`,
            {paymentMethodId}
        );

        dispatch({
            type: "UpdateStudentNotificationDataSuccess",
            payload: data,
        });
        return Promise.resolve(); // Indicate success
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "UpdateStudentNotificationDataFailure",
            payload: error,
        });
        return Promise.reject(); // Indicate failure

    }
};

//UpdateSettingsOpenDisputeTable data
export const UpdateSettingsOpenDisputeTable = (UserId,formData) => async (dispatch) => {
    try {
        console.log("UserId in UpdateSettingsOpenDisputeTable action is:", UserId)
        console.log("formData in UpdateSettingsOpenDisputeTable action is:", formData)

        dispatch({
            type: "UpdateStudentNotificationDataRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/student/settings/UpdateSettingsOpenDisputeTable/${UserId}`,
            formData
        );

        dispatch({
            type: "UpdateStudentNotificationDataSuccess",
            payload: data,
        });
        return Promise.resolve(); // Indicate success
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "UpdateStudentNotificationDataFailure",
            payload: error,
        });
        return Promise.reject(); // Indicate failure
    }
};

//GetSettingsOpenDisputeTable data
export const GetSettingsOpenDisputeData = (UserId) => async (dispatch) => {
    try {
        console.log("UserId in GetSettingsOpenDisputeData action is:", UserId)

        dispatch({
            type: "GetSettingsOpenDisputeDataRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/student/settings/GetSettingsOpenDisputeData/${UserId}`
        );

        dispatch({
            type: "GetSettingsOpenDisputeDataSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetSettingsOpenDisputeDataFailure",
            payload: error,
        });
    }
};

//get institute info from the database
export const GetInstituteInformation = (InstituteId) => async (dispatch) => {
    try {
        console.log("InstituteId in GetInstituteInformation action is:", InstituteId)

        dispatch({
            type: "GetInstituteInformationRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/student/getinstituteinfo/${InstituteId}`
        );

        dispatch({
            type: "GetInstituteInformationSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetInstituteInformationFailure",
            payload: error,
        });
    }
};

//get institute info from the database
export const GetInstituteAddressInformation = (InstituteId) => async (dispatch) => {
    try {
        console.log("InstituteId in GetInstituteAddressInformation action is:", InstituteId)

        dispatch({
            type: "GetInstituteAddressInformationRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/student/getinstituteaddressinfo/${InstituteId}`
        );

        dispatch({
            type: "GetInstituteAddressInformationSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetInstituteAddressInformationFailure",
            payload: error,
        });
    }
};

//get one institute all courses
export const GetOneInstituteAllCourses = (InstituteId) => async (dispatch) => {
    try {
        console.log("InstituteId in GetOneInstituteAllCourses action is:", InstituteId)

        dispatch({
            type: "GetOneInstituteAllCoursesDataRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/student/getoneinstitutecoursesinfo/${InstituteId}`
        );

        dispatch({
            type: "GetOneInstituteAllCoursesDataSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetOneInstituteAllCoursesDataFailure",
            payload: error,
        });
    }
};

//get one institute Training Stats
export const GetOneInstituteTrainingStats = (InstituteId) => async (dispatch) => {
    try {
        console.log("InstituteId in GetOneInstituteTrainingStats action is:", InstituteId)

        dispatch({
            type: "GetOneInstituteTrainingStatsDataRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/student/GetOneInstituteTrainingStats/${InstituteId}`
        );

        dispatch({
            type: "GetOneInstituteTrainingStatsDataSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetOneInstituteTrainingStatsDataFailure",
            payload: error,
        });
    }
};

//GetFeedbackPageData data
export const GetFeedbackPageData = (EnrollmentId) => async (dispatch) => {
    try {
        console.log("EnrollmentId in GetFeedbackPageData action is:", EnrollmentId)

        dispatch({
            type: "GetFeedbackPageDataRequest",
        });
        const { data } = await axiosInstance.get(
            `/api/GetFeedbackPageData/${EnrollmentId}`,
        );

        dispatch({
            type: "GetFeedbackPageDataSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetFeedbackPageDataFailure",
            payload: error,
        });
    }
};

//UpdateSettingsOpenDisputeTable data
export const UpdateFeedbackDataInDatabase = (feedbackPayload, EnrollmentId) => async (dispatch) => {
    try {
        console.log("feedbackPayload in GetFeedbackPageData action is:", feedbackPayload)
        console.log("EnrollmentId in GetFeedbackPageData action is:", EnrollmentId)

        dispatch({
            type: "UpdateFeedbackPageDataRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/UpdateFeedbackPageData/${EnrollmentId}`,
            feedbackPayload
        );

        dispatch({
            type: "UpdateFeedbackPageDataSuccess",
            payload: data,
        });
        return Promise.resolve(); // Indicate success
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "UpdateFeedbackPageDataFailure",
            payload: error,
        });
        return Promise.reject(); // Indicate failure
    }
};

export const GetVLIAgentsA = () => async (dispatch) => {
    try {
        dispatch({
            type: "GetVLIAgentsARequest",
        });

        const { data } = await axiosInstance.post(`/api/GetVLIAgentsA`);

        dispatch({
            type: "GetVLIAgentsASuccess",
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: "GetVLIAgentsAError",
            payload: error,
        });
    }
};

export const UpdateVLIAgentsReferrals = (AgentName,AgentId) => async (dispatch) => {
    console.log("AgentName in UpdateVLIAgentsReferrals is:",AgentName)
    console.log("AgentId in UpdateVLIAgentsReferrals is:",AgentId)

    try {
        dispatch({
            type: "UpdateVLIAgentsRequest",
        });

        const { data } = await axiosInstance.post(`/api/UpdateVLIAgentsReferrals`,{
            AgentId,
            AgentName
        });

        dispatch({
            type: "UpdateVLIAgentsSuccess",
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: "UpdateVLIAgentsError",
            payload: error,
        });
    }
};

export const GetInstitutePackagesDetails = () => async (dispatch) => {
    try {
        dispatch({
            type: "GetInstitutePackagesDetailsRequest",
        });

        const { data } = await axiosInstance.post(`/api/GetInstitutePackagesDetails`);

        dispatch({
            type: "GetInstitutePackagesDetailsSuccess",
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: "GetInstitutePackagesDetailsError",
            payload: error,
        });
    }
};

export const FetchInstituteTrainingAndOfficeHours = (instituteId) => async (dispatch) => {
    try {
        dispatch({
            type: "FetchInstituteTrainingAndOfficeHoursRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/NewInstitute/FetchInstituteTrainingAndOfficeHours/${instituteId}`
        );

        dispatch({
            type: "FetchInstituteTrainingAndOfficeHoursSuccess",
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: "FetchInstituteTrainingAndOfficeHoursError",
            payload: error?.response?.data ? error?.response?.data : {},
        });

    }
};

export const UpdateInstituteTrainingAndOfficeHours = (officeSlots, trainingSlots, instituteId, cb) => async (dispatch) => {
    try {
        dispatch({
            type: "UpdateInstituteTrainingAndOfficeHoursRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/NewInstitute/UpdateInstituteTrainingAndOfficeHours/${instituteId}`,
             {
                officeSlots,
                trainingSlots
            }
        );

        dispatch({
            type: "UpdateInstituteTrainingAndOfficeHoursSuccess",
            payload: data,
        });

        cb();
    } catch (error) {
        dispatch({
            type: "UpdateInstituteTrainingAndOfficeHoursError",
            payload: error?.response?.data ? error?.response?.data : {},
        });

    }
};

export const FetchInstituteOwnersProfileData = (instituteId) => async (dispatch) => {
    try {
        dispatch({
            type: "FetchInstituteOwnersProfileDataRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/NewInstitute/FetchInstituteOwnersProfileData/${instituteId}`
        );

        dispatch({
            type: "FetchInstituteOwnersProfileDataSuccess",
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: "FetchInstituteOwnersProfileDataError",
            payload: error?.response?.data ? error?.response?.data : {},
        });

    }
};

export const UpdateInstituteOwnersProfileData = (instituteId, FormData, cb) => async (dispatch) => {
    try {
        dispatch({
            type: "UpdateInstituteOwnersProfileDataRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/NewInstitute/UpdateInstituteOwnersProfileData/${instituteId}`,
            {
                FormData
            }
        );

        dispatch({
            type: "UpdateInstituteOwnersProfileDataSuccess",
            payload: data,
        });

        cb();
    } catch (error) {
        dispatch({
            type: "UpdateInstituteOwnersProfileDataError",
            payload: error?.response?.data ? error?.response?.data : {},
        });

    }
};

//Get Institute Notification data
export const GetInstituteNotificationData = (UserId) => async (dispatch) => {
    try {
        console.log("UserId in GetInstituteNotificationData action is:", UserId)

        dispatch({
            type: "GetStudentNotificationDataRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/institute/settings/NotificationsData/${UserId}`
        );

        dispatch({
            type: "GetStudentNotificationDataSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetStudentNotificationDataFailure",
            payload: error,
        });
    }
};

//Update institute Notification Personal data
export const UpdateInstitutePersonalNotificationData = (UserId, notifications, cb) => async (dispatch) => {
    try {
        console.log("UserId in UpdateInstitutePersonalNotificationData action is:", UserId)
        console.log("notifications in UpdateInstitutePersonalNotificationData action is:", notifications)

        dispatch({
            type: "UpdateStudentNotificationDataRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/institute/settings/UpdateNotificationsData/${UserId}`,
            { notifications }
        );

        dispatch({
            type: "UpdateStudentNotificationDataSuccess",
            payload: data,
        });

        cb();
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "UpdateStudentNotificationDataFailure",
            payload: error,
        });
    }
};


export const FetchInstituteData = (instituteId) => async (dispatch) => {
    try {
        dispatch({
            type: "FetchInstituteDataRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/NewInstitute/FetchInstituteData/${instituteId}`
        );

        dispatch({
            type: "FetchInstituteDataSuccess",
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: "FetchInstituteDataError",
            payload: error?.response?.data ? error?.response?.data : {},
        });

    }
};

export const GetStudentDetailsA = (UserId) => async (dispatch) => {
    try {
        dispatch({
            type: "GetStudentDetailsRequest",
        });

        const { data } = await axiosInstance.get(
            `/api/GetStudentDetails/${UserId}`
        );
        dispatch({
            type: "GetStudentDetailsSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetStudentDetailsFailure",
            payload: error,
        });
    }
};